import axios from "axios";
import { authenticateService } from "./CommonService";
import { client } from "../Context/orgContext";

export const getReportData = async (sessionId) => {
  const token = await authenticateService();
  if (token.jwt) {
    return axios
      .get(
        `/api/v1/endUser/admin/dashboard/assessmentReportStats/viewUserAssessmentReports?encryptedSessionId=${sessionId}&domainName=${client}`,
        {
          headers: {
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  }
};

export const getBodyPartsStats = async (sessionId) => {
  const token = await authenticateService();
  if (token.jwt) {
    return axios
      .get(
        `/api/v1/endUser/assessmentReportStats/bodyPartExerciseStats?encryptedSessionId=${sessionId}`,
        {
          headers: {
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  }
};

export const getListOfUserAssessmentReports = async (
  page,
  userId,
  sort,
  filter
) => {
  const token = await authenticateService();
  if (token.jwt) {
    return axios
      .get(
        `/api/v1/endUser/admin/dashboard/assessmentReportStats/getAssessmentReportStats/endUser?page=${page}&size=20&endUserId=${userId}&organisationDomainName=${client}&filter=${filter}&sort=${sort}`,
        {
          headers: {
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  }
};

export const sendEmailService = async (encryptedSessionId) => {
  const token = await authenticateService();
  if (token.jwt) {
    return axios
      .get(
        `/api/v1/endUser/admin/dashboard/sendEmail?encryptedSessionId=${encryptedSessionId}`,
        {
          headers: {
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  }
};

export const archiveReportService = async (encryptedSessionId,flag) => {
  const token = await authenticateService();
  if (token.jwt) {
    return axios
      .get(
        `/api/v1/endUser/admin/dashboard/archiveReport?encryptedSessionId=${encryptedSessionId}&archive=${flag}`,
        {
          headers: {
            Authorization: `Bearer ${token.jwt}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        return error;
      });
  }
};
